export default __webpack_public_path__ + "static/media/recommendation_strong_ideas.0d51b3d5.pdf";